import React from "react";
import styled from "styled-components";

interface ISpaceProps {
  height?: string;
}

const StyledSpacer = styled.div<ISpaceProps>`
  display: block;
  width: 100%;
  height: ${(props) => (props?.height ? props?.height : "1em")};
`;

const Spacer = (props: ISpaceProps) => {
  return <StyledSpacer height={props?.height} />;
};

export default Spacer;
